@if (products.length > 0) {
  <table odxTable [data]="dataToDisplay" [headerData]="headerData" (checked)="checkAll($event)" (filtered)="filter($event)">
    @for (product of dataToDisplay; track $index) {
      <tr odx-table-row>
        <td odx-table-cell [(checked)]="product.selected" (checkedChange)="onSelectionChanged()"></td>
        <td odx-table-cell>{{ product.id }}</td>
        <td odx-table-cell>{{ product.name }}</td>
        <td odx-table-cell>{{ product.productId }}</td>
        <td odx-table-cell>{{ product.displayName }}</td>
        <td odx-table-cell>{{ product.floorplanName }}</td>
        <td odx-table-cell>{{ product.notes }}</td>
      </tr>
    }
  </table>
} @else {
  <div class="padding-top" i18n="@@groupConfiguration.table.noProducts">Keine Produkte zum Anzeigen verfügbar.</div>
}
